export function normalizePercent(value: unknown): number {
  const n = typeof value === "number" ? value : Number(value);
  if (!Number.isFinite(n)) return 0;

  // Some APIs return a ratio (0..1), others return a percent (0..100).
  const percent = n >= 0 && n <= 1 ? n * 100 : n;

  // Clamp to a sane display range.
  if (percent < 0) return 0;
  if (percent > 100) return 100;
  return percent;
}
